import { render, staticRenderFns } from "./InfoSidebar.vue?vue&type=template&id=40b20e39&scoped=true&"
import script from "./InfoSidebar.vue?vue&type=script&setup=true&lang=ts&"
export * from "./InfoSidebar.vue?vue&type=script&setup=true&lang=ts&"
import style0 from "./InfoSidebar.vue?vue&type=style&index=0&id=40b20e39&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40b20e39",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/prodoctorov/pd-ssr/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('40b20e39')) {
      api.createRecord('40b20e39', component.options)
    } else {
      api.reload('40b20e39', component.options)
    }
    module.hot.accept("./InfoSidebar.vue?vue&type=template&id=40b20e39&scoped=true&", function () {
      api.rerender('40b20e39', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/common/InfoSidebar/InfoSidebar.vue"
export default component.exports